import ApisMethods from './apisMethods'
import Apiservices from '../../lib/ApiServices'

const VENDOR_API_ORIGIN = 'https://vendor.api.koninstore.com'

export type VendorPaymentMethodPayload = {
  factory_name: string
  environment: 'sandbox' | 'live'
  country_payment_gateway_id?: number
  keys: Record<string, string>
  is_enabled?: boolean
  is_default?: boolean
}

const VendorPaymentMethodsApi = {
  list: (callback: any, setIsLoading: any) => {
    ApisMethods().get(`/vendor/payment-methods`, callback, setIsLoading)
  },

  create: (data: VendorPaymentMethodPayload, callback: any, setIsLoading: any) => {
    ApisMethods().post(`/vendor/payment-methods`, data, callback, setIsLoading)
  },

  update: (id: number, data: Partial<VendorPaymentMethodPayload>, callback: any, setIsLoading: any) => {
    ApisMethods().put(`/vendor/payment-methods/${id}`, data, callback, setIsLoading)
  },

  remove: (id: number, callback: any, setIsLoading: any) => {
    ApisMethods().destroy(`/vendor/payment-methods/${id}`, callback, setIsLoading)
  },

  toggle: (id: number, is_enabled: boolean, callback: any, setIsLoading: any) => {
    ApisMethods().put(
      `/vendor/payment-methods/${id}/toggle`,
      {is_enabled},
      callback,
      setIsLoading
    )
  },

  testById: (id: number, callback: any, setIsLoading: any) => {
    ApisMethods().post(`/vendor/payment-methods/${id}/test`, {}, callback, setIsLoading)
  },

  /** Validate credentials before create (no id yet). */
  testCredentials: (data: VendorPaymentMethodPayload, callback: any, setIsLoading: any) => {
    ApisMethods(true).post(`/vendor/payment-methods/test`, data, callback, setIsLoading)
  },

  getAvailableForCountry: async (
    countryId: number,
    purpose: string = 'customer_checkout'
  ): Promise<any[]> => {
    if (!countryId) {
      return []
    }
    try {
      const res = await Apiservices.get(
        `${VENDOR_API_ORIGIN}/api/countries/${countryId}/payment-gateways`,
        {params: {purpose}}
      )
      return res?.data?.data?.gateways || []
    } catch {
      return []
    }
  },

  getMetrics: (period: string, callback: any, setIsLoading: any) => {
    ApisMethods().get(
      `/vendor/payment-methods/metrics?period=${encodeURIComponent(period)}`,
      callback,
      setIsLoading
    )
  },

  getTransactions: (
    params: {
      period?: string
      gateway?: string
      environment?: string
      status?: string
      page?: number
      per_page?: number
    },
    callback: any,
    setIsLoading: any
  ) => {
    const search = new URLSearchParams()
    search.set('period', params.period ?? '7d')
    if (params.gateway && params.gateway !== 'all') search.set('gateway', params.gateway)
    if (params.environment && params.environment !== 'all') {
      search.set('environment', params.environment)
    }
    if (params.status) search.set('status', params.status)
    search.set('page', String(params.page ?? 1))
    search.set('per_page', String(params.per_page ?? 20))

    ApisMethods().get(
      `/vendor/payment-methods/transactions?${search.toString()}`,
      callback,
      setIsLoading
    )
  },
}

export default VendorPaymentMethodsApi
